import React, { useState, useEffect } from 'react'
import {
  Grow,
  Container,
  Grid,
  CircularProgress,
  Typography,
  Paper,
  Avatar,
  Button,
} from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { getUser } from '../../actions/user'
import FloatingButton from '../../components/FloatingButton/FloatingButton.js'
import Room from '../../components/Rooms/Room/Room.js'
import useStyles from './styles.js'
import ProfileForm from '../../components/ProfileForm/ProfileForm'
import { getPosts } from '../../actions/posts'

const Profile = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [currentId, setCurrentId] = useState(0)
  const [userNow] = useState(JSON.parse(localStorage.getItem('profile')))
  const { posts, isLoading } = useSelector((state) => state.posts)
  const { user } = useSelector((state) => state.user)
  const { username } = useParams()
  const [open, setOpen] = useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    dispatch(getUser(username))
  }, [dispatch, username])

  useEffect(() => {
    dispatch(getPosts())
  }, [dispatch, username])

  if (isLoading) {
    return <CircularProgress size='5em' style={{ marginTop: '80px' }} />
  }

  if (!posts)
    return (
      <Typography variant='body2' style={{ marginTop: '100px' }}>
        No rooms
      </Typography>
    )
  if (!user)
    return (
      <Typography variant='body2' style={{ marginTop: '100px' }}>
        No user
      </Typography>
    )

  return (
    <Grow in>
      <Container maxWidth='lg' className={classes.container}>
        <Grid
          container
          className={classes.gridContainer}
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            lg={3}
            className={classes.profilGrid}
          >
            <Paper elevation={3} className={classes.profilePaper}>
              <Grid className={classes.profileContainer}>
                <Avatar
                  className={classes.profilePic}
                  alt={user?.username}
                  src={user?.avatar}
                >
                  {user?.username.charAt(0)}
                </Avatar>
              </Grid>
              <Grid item className={classes.profileDetails}>
                <Typography variant='h5' className={classes.profileName}>
                  {user?.name || null}
                </Typography>
                <Typography
                  variant='body2'
                  component='p'
                  color='textSecondary'
                  className={classes.userName}
                >
                  @{user?.username}
                </Typography>
                {userNow?.result?.username === user?.username ? (
                  <div>
                    <Button
                      variant='contained'
                      className={classes.followeditButton}
                      onClick={handleClickOpen}
                    >
                      Edit Profile
                    </Button>
                    <ProfileForm
                      open={open}
                      handleClose={handleClose}
                      user={user}
                      username={username}
                    />
                  </div>
                ) : null}

                <Typography variant='body2' className={classes.bio}>
                  {user?.bio}
                </Typography>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={12} md={9} className={classes.roomContainer}>
            <Paper elevation={3} className={classes.paperTab}>
              <Typography variant='body2' className={classes.tabTitle}>
                🏢 ROOMS
              </Typography>
            </Paper>
            <Grid container alignItems='stretch' spacing={3}>
              {posts.map((post) =>
                user?.username === post.username ? (
                  <Grid key={post._id} item xs={12} sm={12} md={4} lg={4}>
                    <Room
                      post={post}
                      currentId={currentId}
                      setCurrentId={setCurrentId}
                    />
                  </Grid>
                ) : null
              )}
            </Grid>
          </Grid>
        </Grid>
        <FloatingButton currentId={currentId} setCurrentId={setCurrentId} />
      </Container>
    </Grow>
  )
}

export default Profile
